var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.926 6.394c0-.858-.818-1.146-1.447-1.146h-4.17c.313-.264.852-1.12 1.134-2.682.016-.086.04-.82.034-.865C11.356.902 10.947.315 10.4.096 9.64-.21 8.902.256 8.93.878c.025.585-.262 2.048-.434 2.628-.203.682-.804.963-1.194 1.44-.47.576-1.521.415-1.535.73-.035.812-.545 1.046-.572 1.046v7.82s7.379.08 7.815 0c.436.08 1.614-.758 1.67-1.61 0-.851-.682-.74-.682-.74s1.213-.307 1.213-1.142-.488-.93-.488-.93 1.227-.237 1.227-1.16c0-.426-.646-.752-1.13-.75.315 0 1.106-.607 1.106-1.816M0 15.54h3.946v-8.89H0z"
})));
export default SvgFacebookMobileLike;